import { QueryKey } from '@tanstack/react-query';

import { Rewards } from '@arrived/models';

export const promotionsKeyFn = (filters?: Rewards.PromotionFilters): QueryKey =>
  ['promotions', 'filters'].concat(filters ? [new URLSearchParams(filters as Record<string, string>).toString()] : []);
export const promotionKeyFn = (promotionUuid: string): QueryKey => ['promotions', promotionUuid];
export const promotionUsageKeyFn = (promotionUuid: string): QueryKey =>
  (promotionKeyFn(promotionUuid) as string[]).concat(['usage']);
export const promotionCodesKeyFn = (promotionUuid: string): QueryKey =>
  (promotionKeyFn(promotionUuid) as string[]).concat(['codes']);

export const promotionsRedemptionKeyFn = (promotionRedemptionUuid: string): QueryKey => [
  'promotion-redemptions',
  promotionRedemptionUuid,
];

export const rewardsAccountsKeyFn = (filters?: Rewards.AccountFilters): QueryKey =>
  ['accounts', 'filters'].concat(filters ? [new URLSearchParams(filters as Record<string, string>).toString()] : []);

export const voucherKey = ['vouchers', 'currentUser'];
export const voucherUnusedKey = ['vouchers', 'currentUser', 'available'];
export const voucherAppliedKey = ['vouchers', 'currentUser', 'applied'];
export const vouchersKeyFn = (uuid: string): QueryKey => ['vouchers', uuid];

export const rewardsRedemptionKeyFn = (rewardRedemptionUuid: string): QueryKey => [
  'rewards-redemptions',
  rewardRedemptionUuid,
];
